import MainAuth from '../pages/auth/Login/MainAuth.jsx';
import Dashboard from '../pages/dashboard/Dashboard.jsx';

export const initialRoutes = () => [
  // Auth Routes
  {
    path: "/",
    type: "auth",
    component: MainAuth,
    title: "Login",
  },
  {
    path: "/dashboard",
    type: "private",
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: "*",
    type: "private",
    component: Dashboard,
    title: "Dashboard",
  },

];

